import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarDays } from "lucide-react";
import { api, fmtDate, textOn } from "@/lib/api";
import { useCentro } from "@/lib/centro";

export const SabadosProximos = () => {
  const { centro } = useCentro();
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/sabados-proximos", { params: { n: 4, centro } }).then((r) => setRows(r.data));
  }, [centro]);
  if (!rows) return null;
  return (
    <div className="mb-8 bg-white border border-slate-200 rounded-lg p-4 fade-up" data-testid="sabados-proximos">
      <div className="flex items-center gap-2 mb-3">
        <CalendarDays className="h-5 w-5 text-[#1E3A8A]" />
        <p className="text-sm font-semibold text-slate-800">Próximos sábados</p>
        <span className="text-[11px] text-slate-500">Quién tiene huecos ese día. Para quitar a alguien, ve a la agenda de ese sábado.</span>
      </div>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {rows.map((s) => (
          <div key={s.fecha} className="rounded-md border border-slate-100 bg-slate-50 p-3" data-testid={`sabado-${s.fecha}`}>
            <p className="text-xs font-semibold text-slate-700 mb-2">{fmtDate(s.fecha)}{s.festivo ? " · festivo" : ""}</p>
            {s.profesionales.length ? (
              <div className="flex flex-wrap gap-1.5">
                {s.profesionales.map((p) => (
                  <span key={p.id} className="rounded px-2 py-0.5 text-[11px] font-medium" style={{ background: p.color, color: textOn(p.color) }} data-testid={`sabado-${s.fecha}-${p.id}`}>
                    {p.nombre.split(" ")[0]} · {p.llenos}/{p.total}
                  </span>
                ))}
              </div>
            ) : <p className="text-[11px] text-slate-400">Nadie trabaja</p>}
          </div>
        ))}
      </div>
      <Link to="/agenda" className="mt-2 inline-block text-[11px] text-[#1E3A8A] underline" data-testid="sabados-ir-agenda">Ir a la agenda</Link>
    </div>
  );
};
